import React, {useEffect, useRef, useState} from "react";
import {
    IonContent,
    IonIcon,
    IonButton,
    IonModal,
    IonToolbar,
    IonButtons,
    IonHeader, IonFooter
} from "@ionic/react";
import {arrowBack, funnel, funnelOutline} from "ionicons/icons";
import AssignmentsFilterSheetModal from "../components/AssignmentsFilterSheetModal";
import useStore from "../zustand/useStore";
import {FacebookLoader} from "../components/Loader/FacebookLoader";
import NoDataFoundOrSelectedDiv from "../components/NoDataFoundOrSelectedDiv";
import {_getExpiryDateFromRange} from "../apiHelpers/CommonHelper";
import {actionToGetRfpAssignmentDataByFilter} from "../apiHelpers/CommonAction";
import AssignmentDataCard from "../components/AssignmentDataCard";

export default function AssignmentMobilePage({isOpen,onDidDismiss,myPostsData}) {
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [filterTypeSelection,setFilterTypeSelection] = useState('Days Left');
    const {
        selectedRetainership,
        selectedExpiryDate,
        selectedPrice,
        selectedAssignmentLocation,
        rfpAssignmentDataState,
        setAssignmentDetail,
        setIsAssignmentDetailOpen
    } = useStore();
    const {loading,assignments,totalCount } = rfpAssignmentDataState;
    const isFetchingRef = useRef(false);
    const observerRef = React.useRef(null);


    const handleDetailItemClick = (jobDetail)=>{
        setAssignmentDetail(jobDetail);
        setIsAssignmentDetailOpen(true);
    }

    const callFunctionToSetIsFilterOpen = (type)=>{
        setFilterTypeSelection(type);
        setIsFilterOpen(true);
    }

    const callFunctionToFilterAssignmentPosting = async (isLoad = true)=>{
        if (isFetchingRef.current) return;
        isFetchingRef.current = true;
        const payload = {};
        if (selectedRetainership) payload.retainership = selectedRetainership;
        if (selectedExpiryDate) payload.expiry_date = _getExpiryDateFromRange(selectedExpiryDate);
        if (selectedPrice) payload.price_max = selectedPrice;
        if (selectedAssignmentLocation.length > 0) payload.location = selectedAssignmentLocation;
        payload.me_mode = !!myPostsData;
        await actionToGetRfpAssignmentDataByFilter(isLoad,payload);
        isFetchingRef.current = false;
    }

    const showApplyButton =
        selectedRetainership ||
        selectedExpiryDate ||
        selectedAssignmentLocation.length > 0 ||
        selectedPrice > 0

    const lastJobElementRef = React.useCallback(
        (node) => {
            if (observerRef.current) observerRef.current.disconnect();

            observerRef.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && assignments?.length < totalCount) {
                    callFunctionToFilterAssignmentPosting(false); // Load next page
                }
            });

            if (node) observerRef.current.observe(node);
        },
        [totalCount,assignments, callFunctionToFilterAssignmentPosting]
    );

    useEffect(() => {
        if(isOpen) {
            callFunctionToFilterAssignmentPosting();
        }
    },[isOpen])

    const panelSubHeader = ()=>{
        return (
            <div className={`filter-header-wrapper`}>
                <div className="filter-header assignment_filter_wraper assignment">
                    <IonButton fill="clear" size="small" onClick={() => callFunctionToSetIsFilterOpen('Assignment Type')}
                               className={`filter-btn ${showApplyButton ? 'active' : ''}`}>
                        {(showApplyButton) ?
                            <IonIcon icon={funnel} slot="start"/>
                            :
                            <IonIcon icon={funnelOutline} slot="start"/>
                        }
                    </IonButton>
                    <div className="tags">
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Assignment Type' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Assignment Type')}>Assignment Type</span>
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Location' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Location')}>Location</span>
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Maximum Price<' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Maximum Price<')}>Maximum Price</span>
                        <span className={`tag ${showApplyButton && filterTypeSelection === 'Days Left' ? 'active' : ''}`}
                              onClick={() => callFunctionToSetIsFilterOpen('Days Left')}>Days Left</span>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            <IonHeader className="job_detail_sheet_header sheet_modal_header">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton className={"close_job_post_button"} onClick={onDidDismiss}>
                            <IonIcon icon={arrowBack}/>
                        </IonButton>
                    </IonButtons>
                    <div className="job_detail_sheet_header_text">
                        <div className="job-basic-info-image">
                            <span className="job-basic-info-text">
                                {myPostsData ? 'My' : ''} Assignment Posts List
                            </span>
                        </div>
                    </div>
                </IonToolbar>
                <IonToolbar>
                    {panelSubHeader()}
                </IonToolbar>
            </IonHeader>
            <IonContent className="mobile-job-list-page page-content">

                {(loading) ?
                    <div className="job-list">
                        <div className="job-card">
                            <FacebookLoader type={"facebookStyle"} item={1}/>
                        </div>
                        <div className="job-card">
                            <FacebookLoader type={"facebookStyle"} item={1}/>
                        </div>
                        <div className="job-card">
                            <FacebookLoader type={"facebookStyle"} item={1}/>
                        </div>
                    </div>
                    :
                    (assignments && assignments?.length > 0) ?
                        <div className="job-list">
                            {assignments.map((assignment, index) => {
                                if (index === assignments.length - 1) {
                                    return (
                                        <div ref={lastJobElementRef} key={assignment.id}>
                                            <AssignmentDataCard
                                                assignment={assignment}
                                                key={assignment.id}
                                                handleDetailItemClick={handleDetailItemClick}
                                            />
                                        </div>
                                    );
                                }
                                return (
                                    <AssignmentDataCard
                                        assignment={assignment}
                                        key={assignment.id}
                                        handleDetailItemClick={handleDetailItemClick}
                                    />
                                );
                            })}
                        </div>
                        :
                        <div className="job-list">
                            <NoDataFoundOrSelectedDiv/>
                        </div>
                }
            </IonContent>
            <IonFooter className={"blank_footer_bar"}>
                <IonToolbar>

                </IonToolbar>
            </IonFooter>
            {(isFilterOpen) ?
            <AssignmentsFilterSheetModal
                isOpen={isFilterOpen}
                myPostsData={myPostsData}
                filterTypeSelection={filterTypeSelection}
                setFilterTypeSelection={setFilterTypeSelection}
                onDidDismiss={() => setIsFilterOpen(false)}
            />:''
            }
        </IonModal>
    );
}
